import { BlueOutlineButton } from "components/components/BlueOutlineButton/BlueOutlineButton";
import styled from "styled-components";

export const CancelButton = styled(BlueOutlineButton)`
  && {
    width: auto;
  }
`;
